var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userstate"},[_c('signModule',{attrs:{"inputState":_vm.status>=1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }